/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Nav_LabsInputs */

const en_ui_nav_labs = /** @type {(inputs: Ui_Nav_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labs`)
};

const de_ui_nav_labs = /** @type {(inputs: Ui_Nav_LabsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Labs`)
};

/**
* | output |
* | --- |
* | "Labs" |
*
* @param {Ui_Nav_LabsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_nav_labs = /** @type {((inputs?: Ui_Nav_LabsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Nav_LabsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_nav_labs(inputs)
	return de_ui_nav_labs(inputs)
});